<template>
    <div class="ScenarioDialogContainer">
        <Setting ref="Setting"></Setting>
        <ScenarioEditor ref="ScenarioEditor"></ScenarioEditor>
        <ScenarioAdvanceSearch ref="ScenarioAdvanceSearch"></ScenarioAdvanceSearch>
        <StepEditor ref="StepEditor"></StepEditor>
        <StepSelector ref="StepSelector"></StepSelector>
        <VariableSelector ref="VariableSelector"></VariableSelector>
        <VariableEditor ref="VariableEditor"></VariableEditor>
        <CardDialog ref="CardDialog"></CardDialog>
        <ButtonSelector ref="ButtonSelector"></ButtonSelector>
        <CardHelp ref="CardHelp"></CardHelp>
        <ButtonEditor ref="ButtonEditor"></ButtonEditor>
        <BuiltInFuction ref="BuiltInFuction"></BuiltInFuction>
    </div>
</template>

<script>
import { AppEventBus, AppEventBusType } from '@/eventbus/app.eventbus'
import Setting from '@/views/Scenario/Setting/Setting'
import StepEditor from '@/views/Scenario/StepEditor/StepEditor'
import ScenarioEditor from '@/views/Scenario/ScenarioEditor'
import ScenarioAdvanceSearch from '@/views/Scenario/Search/ScenarioAdvanceSearch'
import VariableSelector from '@/views/Scenario/StepEditor/VariableSelector'
import VariableEditor from '@/views/Scenario/Setting/VariableEditor'
import StepSelector from '@/views/Scenario/StepEditor/StepSelector'
import CardDialog from '@/views/Scenario/StepEditor/Card/component/CardDialog'
import ButtonSelector from '@/views/Scenario/StepEditor/Button/ButtonSelector'
import CardHelp from '@/views/Scenario/Help/CardHelp'
import ButtonEditor from '@/views/Scenario/StepEditor/Button/ButtonEditor'
import BuiltInFuction from '@/views/Scenario/StepEditor/CustomDialog/LuaFunction/BuiltInFunction'

export default {
    name: 'ScenarioDialogContainer',
    components: {
        ButtonEditor,
        CardHelp,
        ButtonSelector,
        CardDialog,
        StepSelector,
        VariableEditor,
        VariableSelector,
        ScenarioEditor,
        StepEditor,
        Setting,
        ScenarioAdvanceSearch,
        BuiltInFuction
    },
    mounted () {
        AppEventBus.on('*', this.handleEvent)
    },
    destroyed () {
        AppEventBus.off('*', this.handleEvent)
    },
    methods: {
        handleEvent (type, data) {
            let TypeMap = {
                [AppEventBusType.OPEN_STEP_EDITOR]: 'StepEditor',
                [AppEventBusType.OPEN_SCENARIO_EDITOR]: 'ScenarioEditor',
                [AppEventBusType.OPEN_SETTING]: 'Setting',
                [AppEventBusType.OPEN_VARIABLE_SELECTOR]: 'VariableSelector',
                [AppEventBusType.OPEN_VARIABLE_EDITOR]: 'VariableEditor',
                [AppEventBusType.OPEN_STEP_SELECTOR]: 'StepSelector',
                [AppEventBusType.OPEN_CARD_DIALOG]: 'CardDialog',
                [AppEventBusType.OPEN_BUTTON_SELECTOR]: 'ButtonSelector',
                [AppEventBusType.OPEN_BUTTON_EDITOR]: 'ButtonEditor',
                [AppEventBusType.OPEN_SCENARIO_ADVANCE_SEARCH]: 'ScenarioAdvanceSearch',
                [AppEventBusType.OPEN_CARD_HELP]: 'CardHelp',
                [AppEventBusType.OPEN_BUILT_IN_FUNCTION]: 'BuiltInFuction'
            }
            let refName = TypeMap[type]
            if (refName) {
                let promise = this.$refs[refName].open(data)
                if (promise) {
                    promise.then(data => {
                        AppEventBus.emit(type + '_DONE', data)
                    })
                }
            }
        }
    }
}
</script>
